import React, { Component } from "react";
import Counter from "../Counter/Counter";
import { convertCurrency, formatNumberWithSpaces } from "../../utils";
import CartPopup from "../CartPopup/CartPopup"
import "./Cheque.scss";
import { config, MAX_AMOUNT } from "../../Constants";
import ReusablePopup from "../ReusablePopup/ReusablePopup";
import { getCartTotal } from "../../api";

const getChequeLabels = (product) => {
  if (product.id == process.env.REACT_APP_CHEQUE_CADEAU_ID) {
    return {
      quantity: "Quantité d'enveloppes",
      numberPerUnit: "Nombre de chèques par enveloppe",
      value: "Valeur du chèque",
      name: "Nom sur le chèque",
    };
  }

  return {
    quantity: "Quantité de carnets",
    numberPerUnit: "Nombre de chèques par carnet",
    value: "Valeur du chèque",
    name: "Nom sur le chèque",
  };
};

class Cheque extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: this.props.product,
      price: 0,
      couponValue: (this.props.product.id == process.env.REACT_APP_CHEQUE_REPAS_ID) ? 40 : 100,
      couponNumber: (this.props.product.id == process.env.REACT_APP_CHEQUE_REPAS_ID) ? 26 : 20,
      couponQuantity: 1,
      couponName: "",
      open:false,
      isReusablePopupOpen : false,
    };
  }

  componentDidMount() {
    const { couponValue, couponNumber, couponQuantity, product } = this.state;
    
    // Handle price
    let currentPrice =
      couponQuantity * couponNumber * couponValue +
      parseFloat(product.price);
    this.setState({ price: currentPrice });
  }

  handleChange(e, isString = false) {
    if (!isNaN(parseInt(e.target.value)) || isString) {
      this.setState(
        {
          [e.target.name]: [e.target.value],
        },
        () => {
          const { couponValue, couponNumber, couponQuantity } = this.state;
          this.setState({ price: couponQuantity * couponNumber * couponValue });
        }
      );
    }
  }
  setOpen() {

    this.setState({open:!this.state.open})
  }

  setIsReusablePopupOpen(open=true) {
    this.setState({ isReusablePopupOpen: open });
  }

 async addToCart() {
    const { product, couponName, couponNumber, couponQuantity, couponValue, price } = this.state;
   
    
     /* if (couponName.length===0 || couponName.some(e=>e.trim().length===0)) {
      alert("Merci de saisir le nom du coupon");
      return false;
    } */
    if(product.id == 1 &&  couponValue <2)
    {   
        alert("Le montant minimal de recharge de MOBILE PAY REPAS est de : 2 MAD")
        return false;
    } else if(product.id !=1 && couponValue<10)
      { alert(`Le montant minimal de recharge de ${product.name} est de : 10 MAD`)
        return false;

    }
    const addUrl =  document.getElementById("add-to-cart-or-refresh")?.value || `${config.url}/panier`;
    
    const token = (process.env.REACT_APP_STAGE==='dev')?"6201c3c0310244f2bcffdda74673397a":document.getElementsByName("token")[0].value;
  
    const data = new FormData();
    data.append("token", token);
    data.append("id_product", product.id);
    data.append("qty", couponQuantity);
    data.append("value", couponValue);
    data.append("number", couponNumber);
    data.append("name", couponName);
    data.append("total", price);
    data.append("add", 1);
    data.append("action", "update");

    const postToCart = async () => {
      const response = await fetch(addUrl, {
        method: "POST",
        mode: "cors",
        header: {
          headers: {
            'Accept': 'application/json, application/xml, text/plain, text/html, *.*'
          }
        },
        body: data,
      });
     return response;
    };
   
    
    const getCurrentCartTotal = async () => {
      const cart = window.prestashop?.cart?.totals?.total;
      if (cart && cart.amount) {
        return +cart.amount; 
      }
  
      try {
        const data = await getCartTotal(); 
        return data || 0; 
      } catch (error) {
        console.error("Failed to fetch cart total:", error);
        return 0; 
      }
    };
    const currentCartTotal = await getCurrentCartTotal();
    if (currentCartTotal + price > MAX_AMOUNT) {
      this.setIsReusablePopupOpen(true);
      return;
    } 

    postToCart().then( (resp)=>window.prestashop.emit('updateCart', {
      reason: {}, resp: resp,
    })).then(res=>this.setOpen());  
 
  }

  render() {
    const { open,product, price, couponNumber, couponValue, couponQuantity  } = this.state;
    const labels = getChequeLabels(product);
    let counter;
    if (product.id==process.env.REACT_APP_CHEQUE_REPAS_ID)
          {counter = <Counter
            name="couponValue"
            value={couponValue}
            min={2}
            max={200}
            step={0.5}
            stepInput={1}
            onValueChange={(e) => this.handleChange(e)}
          />}
          else
          {counter =<Counter
            name="couponValue"
            value={couponValue}
            min={10}
            max={999}
            step={0.5}
            stepInput={1}
            onValueChange={(e) => this.handleChange(e)}
          />}
        return (
      <div className="Cheque">
        <h1>{product.name}</h1>
        <p style={{textAlign: "justify"}}>{product.description_short.replace(/<[^>]*>?/gm, '')}</p>
        <p style={{ color: "#C9383F"}}>{convertCurrency(price)}</p>
        <div className="form">
        <div style={{justifyContent: "space-between"}} className="input-group">
          <div className="label">
            <label htmlFor="couponQuantity">{labels.quantity} :</label>
          </div>
          <Counter
            name="couponQuantity"
            value={couponQuantity}
            min={1}
            max={999}
            step={1}
            stepInput={1}
            onValueChange={(e) => this.handleChange(e)}
          />
        </div>
        <div style={{justifyContent: "space-between"}} className="input-group">
          <div style={{textAlign: "justify"}} className="label">
            <label htmlFor="couponNumber">{labels.numberPerUnit} :</label>
          </div>
          <Counter
            name="couponNumber"
            value={couponNumber}
            min={1}
            max={50}
            step={1}
            stepInput={1}
            onValueChange={(e) => this.handleChange(e)}
          />
        </div>
        <div style={{justifyContent: "space-between"}}className="input-group">
          <div className="label">
            <label htmlFor="couponValue">{labels.value} :</label>
          </div>
         {counter}
        </div>
        <div style={{justifyContent: "space-between"}} className="input-group">
          <div style={{textAlign: "initial"}} className="label">
            <label htmlFor="couponName">{labels.name} :</label>
          </div>
          <input
            className="text-input"
            name="couponName"
            maxLength="100"
            value={this.state.couponName}
            onChange={(e) => this.handleChange(e, true)}
          />
        </div>
        </div>
        <div className="product-add-to-cart">
          <div className="add green_btn">
            <button type="submit" onClick={()=>this.addToCart()}>
              Commander
      </button>
          </div>
        </div>
        <CartPopup Produit={this.state.product} Price={this.state.price} Quantity={this.state.couponQuantity} quantityLabel={labels.quantity} setOpen={()=>this.setOpen()} open={open} />
        <ReusablePopup
        isOpen={this.state.isReusablePopupOpen}
        onClose={() => this.setIsReusablePopupOpen(false)}
        title="Limite du panier dépassée"
        message={
          <>
            Merci de contacter le service client ou le service commercial au{" "}
            <a href="tel:+212520012121" style={{ color: "blue", textDecoration: "underline" }}>
              [+212 520-012121]
            </a>.
          </>
        }
        actions={<button className="green_btn" onClick={() => this.setIsReusablePopupOpen(false)}>Fermer</button>}
      />
      </div>
    );
  }
}

export default Cheque;
